import { Modal } from 'react-bootstrap';

interface ModalInterface {
  isModalOpen: boolean;
  onClose: any;
  closeOnBackdrop?: boolean,
  children: JSX.Element;
}

export default function MessageModal({
  isModalOpen = false,
  onClose,
  closeOnBackdrop = true,
  children }: ModalInterface) {

  return (
    <Modal
      size='lg'
      show={isModalOpen}
      onHide={onClose}
      backdrop={closeOnBackdrop ? true : 'static'}
      dialogClassName='dark-modal'>
      <Modal.Body>
        {children}
      </Modal.Body>
    </Modal>
  );
}
